/* eslint-disable security/detect-object-injection */
import React, { useContext, useState } from 'react';
import { appointmentLanguageContent } from '../../pages/Appointments/appointmentLanguageContent';
import ApplicationContext from '../../context/ApplicationContext';

function Dropdown(props) {
    const { selectedLanguage } = useContext(ApplicationContext);
    const { selectedOption, setSelectedOption, placeholder, options, className, dropdownID, showErrorBorder, callback, callbackFunction } = props;
    const [show, setShow] = useState(false);
    return (
        <>
            <button
                onClick={() => setShow(!show)}
                data-testid={dropdownID}
                className={`border ${showErrorBorder ? 'border-[#B51803]' : 'border-[#797979]'} h-[40px] px-3 py-4 flex justify-between items-center w-full font-normal text-sm mt-1  ${selectedOption ===  '' ? 'text-[#797979]' : 'text-[#333333]'}
                outline-0 ${className}`}
                type="button" aria-expanded="false">
                {selectedOption === '' ? placeholder : dropdownID === "appointment_dropdown" ? appointmentLanguageContent[(selectedOption).toLowerCase().replaceAll(' ', '-')][selectedLanguage] : selectedOption}
                <img loading="lazy" decoding="async"
                    src="/images/arrow-down.svg" alt="arrow" />
            </button>
            <ul id="#patient-dropdownMenuButton1" className={`rounded-[4px] bg-[#F2F2F2] dropdown-menu absolute m-0 shadow-black z-[9999] left-0 hidden  w-full p-2 ${show === true ? 'show' : ''}`}
                aria-labelledby="patient-dropdownMenuButton1">
                {options.map((item, index = 0) => (
                    <li key={index} className="automatic hover:bg-[#F2F4F5] rounded-lg p-2" onClick={(e) => {e.preventDefault(); setShow(false); setSelectedOption(item); callback ? callbackFunction() : ''}}>
                        <a data-testid={`${dropdownID}-${index}`} className="dropdown-item font-normal text-sm text-[#000]"
                            href="/">
                            {dropdownID === "appointment_dropdown" ? appointmentLanguageContent[(item).toLowerCase().replaceAll(' ', '-')][selectedLanguage] : item}
                        </a>
                    </li>
                ))}
            </ul>
            <div className={['filter-overlay cursor-pointer ', show === true ? 'filter-open ' : ''].join('')} onClick={() => setShow(false)} />
        </>
    );
}

export default Dropdown;